var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArena(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 442.123 293.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First_Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "251.363 18.76 234.419 28.186 280.607 54.797 297.55 45.37 251.363 18.76",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.641 54.972 280.641 72.208 297.437 62.44 297.437 45.049 280.641 54.972",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.641 54.817 280.641 72.208 234.433 45.585 234.433 28.194 280.641 54.817",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "251.45 0 234.507 9.427 280.694 36.037 297.638 26.611 251.45 0",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.728 36.213 280.728 53.448 297.524 43.681 297.524 26.29 280.728 36.213",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.728 36.057 280.728 53.448 234.52 26.825 234.52 9.434 280.728 36.057",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "299.261 46.276 282.318 55.702 328.505 82.313 345.449 72.887 299.261 46.276",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.54 82.488 328.54 99.724 345.335 89.957 345.335 72.565 328.54 82.488",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.54 82.333 328.54 99.724 282.331 73.101 282.331 55.71 328.54 82.333",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "299.349 27.516 282.405 36.943 328.592 63.554 345.536 54.127 299.349 27.516",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.627 63.729 328.627 80.965 345.423 71.197 345.423 53.806 328.627 63.729",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.627 63.573 328.627 80.965 282.418 54.341 282.418 36.95 328.627 63.573",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "347.95 74.773 331.007 84.2 377.194 110.811 394.138 101.384 347.95 74.773",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.229 110.986 377.229 128.222 394.024 118.454 394.024 101.063 377.229 110.986",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.229 110.831 377.229 128.222 331.02 101.599 331.02 84.208 377.229 110.831",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "348.038 56.014 331.094 65.44 377.281 92.051 394.225 82.625 348.038 56.014",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.316 92.226 377.316 109.462 394.112 99.694 394.112 82.303 377.316 92.226",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.316 92.071 377.316 109.462 331.107 82.839 331.107 65.448 377.316 92.071",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "395.849 102.29 378.905 111.716 425.093 138.327 442.036 128.9 395.849 102.29",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.127 138.502 425.127 155.738 441.923 145.97 441.923 128.579 425.127 138.502",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.127 138.347 425.127 155.738 378.918 129.115 378.918 111.724 425.127 138.347",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "395.936 83.53 378.992 92.956 425.18 119.567 442.123 110.141 395.936 83.53",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.214 119.743 425.214 136.978 442.01 127.211 442.01 109.819 425.214 119.743",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.214 119.587 425.214 136.978 379.006 110.355 379.006 92.964 425.214 119.587",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "412.41 128.83 373.669 150.869 389.121 159.703 427.862 137.664 412.41 128.83",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.156 159.878 389.156 177.114 427.749 154.734 427.749 137.343 389.156 159.878",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.156 159.723 389.156 177.114 373.974 167.968 373.974 150.577 389.156 159.723",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "412.41 110.021 373.669 132.06 389.121 140.893 427.862 118.855 412.41 110.021",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.156 141.069 389.156 158.304 427.749 135.925 427.749 118.534 389.156 141.069",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.156 140.913 389.156 158.304 373.974 149.159 373.974 131.768 389.156 140.913",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "373.128 151.694 334.387 173.732 349.84 182.566 388.581 160.528 373.128 151.694",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.874 182.741 349.874 199.977 388.467 177.598 388.467 160.206 349.874 182.741",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.874 182.586 349.874 199.977 334.692 190.832 334.692 173.441 349.874 182.586",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "373.128 132.885 334.387 154.923 349.84 163.757 388.581 141.718 373.128 132.885",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.874 163.932 349.874 181.168 388.467 158.788 388.467 141.397 349.874 163.932",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.874 163.777 349.874 181.168 334.692 172.022 334.692 154.631 349.874 163.777",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "334.279 174.407 295.538 196.445 310.991 205.279 349.731 183.241 334.279 174.407",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.025 205.454 311.025 222.69 349.618 200.31 349.618 182.919 311.025 205.454",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.025 205.299 311.025 222.69 295.843 213.545 295.843 196.153 311.025 205.299",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "334.279 155.597 295.538 177.636 310.991 186.47 349.731 164.431 334.279 155.597",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.025 186.645 311.025 203.881 349.618 181.501 349.618 164.11 311.025 186.645",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.025 186.49 311.025 203.881 295.843 194.735 295.843 177.344 311.025 186.49",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "294.997 197.27 256.256 219.309 271.709 228.143 310.45 206.104 294.997 197.27",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.743 228.318 271.743 245.554 310.336 223.174 310.336 205.783 271.743 228.318",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.743 228.162 271.743 245.554 256.561 236.408 256.561 219.017 271.743 228.162",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "294.997 178.461 256.256 200.499 271.709 209.333 310.45 187.295 294.997 178.461",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.743 209.509 271.743 226.744 310.336 204.365 310.336 186.973 271.743 209.509",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.743 209.353 271.743 226.744 256.561 217.599 256.561 200.208 271.743 209.353",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "256.527 220.211 217.786 242.249 233.239 251.083 271.98 229.044 256.527 220.211",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.273 251.258 233.273 268.494 271.866 246.114 271.866 228.723 233.273 251.258",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.273 251.103 233.273 268.494 218.091 259.349 218.091 241.957 233.273 251.103",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "256.527 201.401 217.786 223.44 233.239 232.274 271.98 210.235 256.527 201.401",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.273 232.449 233.273 249.685 271.866 227.305 271.866 209.914 233.273 232.449",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.273 232.294 233.273 249.685 218.091 240.539 218.091 223.148 233.273 232.294",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "233.905 28.592 195.164 50.63 210.617 59.464 249.358 37.425 233.905 28.592",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.651 59.639 210.651 76.875 249.244 54.495 249.244 37.104 210.651 59.639",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.651 59.484 210.651 76.875 195.469 67.73 195.469 50.338 210.651 59.484",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "233.905 9.782 195.164 31.821 210.617 40.655 249.358 18.616 233.905 9.782",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.651 40.83 210.651 58.066 249.244 35.686 249.244 18.295 210.651 40.83",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.651 40.675 210.651 58.066 195.469 48.92 195.469 31.529 210.651 40.675",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "194.624 51.455 155.883 73.494 171.335 82.327 210.076 60.289 194.624 51.455",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.37 82.503 171.37 99.739 209.963 77.359 209.963 59.968 171.37 82.503",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.37 82.347 171.37 99.739 156.187 90.593 156.187 73.202 171.37 82.347",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "194.624 32.646 155.883 54.684 171.335 63.518 210.076 41.48 194.624 32.646",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.37 63.693 171.37 80.929 209.963 58.55 209.963 41.158 171.37 63.693",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.37 63.538 171.37 80.929 156.187 71.784 156.187 54.393 171.37 63.538",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "155.774 74.168 117.033 96.207 132.486 105.04 171.227 83.002 155.774 74.168",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.52 105.216 132.52 122.451 171.113 100.072 171.113 82.681 132.52 105.216",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.52 105.06 132.52 122.451 117.338 113.306 117.338 95.915 132.52 105.06",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "155.774 55.359 117.033 77.397 132.486 86.231 171.227 64.193 155.774 55.359",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.52 86.406 132.52 103.642 171.113 81.262 171.113 63.871 132.52 86.406",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.52 86.251 132.52 103.642 117.338 94.497 117.338 77.105 132.52 86.251",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.493 97.032 77.752 119.07 93.204 127.904 131.945 105.865 116.493 97.032",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.239 128.079 93.239 145.315 131.832 122.935 131.832 105.544 93.239 128.079",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.239 127.924 93.239 145.315 78.056 136.169 78.056 118.778 93.239 127.924",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.493 78.222 77.752 100.261 93.204 109.095 131.945 87.056 116.493 78.222",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.239 109.27 93.239 126.506 131.832 104.126 131.832 86.735 93.239 109.27",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.239 109.114 93.239 126.506 78.056 117.36 78.056 99.969 93.239 109.114",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.023 119.972 39.282 142.01 54.734 150.844 93.475 128.806 78.023 119.972",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.769 151.02 54.769 168.255 93.362 145.876 93.362 128.484 54.769 151.02",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.769 150.864 54.769 168.255 39.586 159.11 39.586 141.719 54.769 150.864",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "78.023 101.163 39.282 123.201 54.734 132.035 93.475 109.996 78.023 101.163",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.769 132.21 54.769 149.446 93.362 127.066 93.362 109.675 54.769 132.21",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.769 132.055 54.769 149.446 39.586 140.301 39.586 122.909 54.769 132.055",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "161.451 239.74 144.507 249.167 190.694 275.777 207.638 266.351 161.451 239.74",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.729 275.953 190.729 293.188 207.525 283.421 207.525 266.03 190.729 275.953",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.729 275.797 190.729 293.188 144.52 266.565 144.52 249.174 190.729 275.797",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "161.538 220.98 144.594 230.407 190.782 257.018 207.725 247.591 161.538 220.98",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.816 257.193 190.816 274.429 207.612 264.661 207.612 247.27 190.816 257.193",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.816 257.038 190.816 274.429 144.607 247.806 144.607 230.414 190.816 257.038",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "217.246 243.074 178.505 265.113 193.957 273.946 232.698 251.908 217.246 243.074",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.992 274.122 193.992 291.358 232.585 268.978 232.585 251.587 193.992 274.122",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.992 273.966 193.992 291.358 178.809 282.212 178.809 264.821 193.992 273.966",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "217.246 224.265 178.505 246.303 193.957 255.137 232.698 233.099 217.246 224.265",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.992 255.312 193.992 272.548 232.585 250.169 232.585 232.777 193.992 255.312",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.992 255.157 193.992 272.548 178.809 263.403 178.809 246.012 193.992 255.157",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.741 142.835 0 164.874 15.452 173.708 54.193 151.669 38.741 142.835",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.487 173.883 15.487 191.119 54.08 168.739 54.08 151.348 15.487 173.883",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.487 173.728 15.487 191.119 .305 181.973 .305 164.582 15.487 173.728",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.741 124.026 0 146.065 15.452 154.898 54.193 132.86 38.741 124.026",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.487 155.074 15.487 172.31 54.08 149.93 54.08 132.539 15.487 155.074",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.487 154.918 15.487 172.31 .305 163.164 .305 145.773 15.487 154.918",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16.965 156.21 .021 165.637 46.208 192.247 63.152 182.821 16.965 156.21",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.243 192.423 46.243 209.659 63.039 199.891 63.039 182.5 46.243 192.423",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.243 192.267 46.243 209.659 .034 183.035 .034 165.644 46.243 192.267",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.052 137.45 .108 146.877 46.296 173.488 63.239 164.061 17.052 137.45",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.33 173.663 46.33 190.899 63.126 181.131 63.126 163.74 46.33 173.663",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.33 173.508 46.33 190.899 .121 164.276 .121 146.885 46.33 173.508",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "64.863 183.726 47.92 193.153 94.107 219.764 111.051 210.337 64.863 183.726",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.141 219.939 94.141 237.175 110.937 227.407 110.937 210.016 94.141 219.939",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.141 219.784 94.141 237.175 47.933 210.552 47.933 193.16 94.141 219.784",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "64.95 164.967 48.007 174.393 94.194 201.004 111.138 191.577 64.95 164.967",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.229 201.179 94.229 218.415 111.024 208.647 111.024 191.256 94.229 201.179",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.229 201.024 94.229 218.415 48.02 191.792 48.02 174.401 94.229 201.024",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "113.552 212.224 96.609 221.65 142.796 248.261 159.74 238.835 113.552 212.224",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.83 248.436 142.83 265.672 159.626 255.905 159.626 238.513 142.83 248.436",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.83 248.281 142.83 265.672 96.622 239.049 96.622 221.658 142.83 248.281",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "113.639 193.464 96.696 202.891 142.883 229.502 159.827 220.075 113.639 193.464",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.918 229.677 142.918 246.913 159.713 237.145 159.713 219.754 142.918 229.677",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.918 229.521 142.918 246.913 96.709 220.29 96.709 202.898 142.918 229.521",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "161.451 239.74 144.507 249.167 190.694 275.777 207.638 266.351 161.451 239.74",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.729 275.953 190.729 293.188 207.525 283.421 207.525 266.03 190.729 275.953",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.729 275.797 190.729 293.188 144.52 266.565 144.52 249.174 190.729 275.797",
    fill: "#ffcead"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "161.538 220.98 144.594 230.407 190.782 257.018 207.725 247.591 161.538 220.98",
    fill: "#f8b98e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.816 257.193 190.816 274.429 207.612 264.661 207.612 247.27 190.816 257.193",
    fill: "#e7b084"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.816 257.038 190.816 274.429 144.607 247.806 144.607 230.414 190.816 257.038",
    fill: "#ffcead"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArena);
export default __webpack_public_path__ + "static/media/arena.e6f3cd2b7d1590bbf4a599e7a1c023d0.svg";
export { ForwardRef as ReactComponent };